import { UNIT_DEFS } from './units';

/*
 * מבני הייצור — **סדר קבוע, ולכן מקור אמת יחיד.**
 *
 * לכל מבנה ייצור יש תור משלו, כמו ב-RA2: הקסרקטין מאמן חי"ר בזמן שהמפעל בונה
 * טנק. האינדקס במערך הזה הוא **מזהה התור בתוך המצב ובתוך השמירה**, ולכן:
 *
 *   - הרשימה מפורשת ולא נגזרת מ-`UNIT_DEFS` באיטרציה. סדר שנגזר מאובייקט משתנה
 *     עם עריכה תמימה, וכל שמירה קיימת נטענת עם התורים מוחלפים.
 *   - **מוסיפים בסוף בלבד.** הזזה של רשומה שוברת שמירות בשקט; `production.test`
 *     מקבע את המיפוי ויפיל כל שינוי סדר.
 */
export const PRODUCER_IDS = ['yard', 'barracks', 'factory', 'airfield'] as const;

export type ProducerId = (typeof PRODUCER_IDS)[number];

/** אינדקס התור של מבנה מייצר. ‎-1 למבנה שאינו מייצר דבר. */
export function producerIndex(id: string): number {
    return PRODUCER_IDS.indexOf(id as ProducerId);
}

/** התור שאליו נכנסת יחידה מסוימת. מבנים נכנסים תמיד לתור המפקדה. */
export function queueOfUnit(unitType: number): number {
    return producerIndex(UNIT_DEFS[unitType]?.producedBy ?? '');
}

/** תור המבנים — המפקדה. שם קבוע במקום 0 פזור בקוד. */
export const YARD_QUEUE = 0;
